import { responseHandlerService } from '@/plugins/responseHandlerService'

/**
 * Regenerate content using the last generation parameters
 * @param {Object} state - Content state object
 * @param {Object} assetStore - Asset store instance
 * @param {Object} generateFuncs - Object containing generation functions
 * @param {Function} t - Translation function
 * @returns {Promise<boolean>} Success status
 */
export const regenerateContent = async (state, assetStore, generateFuncs, t) => {
  // Check if there are previous generation parameters
  if (!state.lastGenerationParams.value) {
    responseHandlerService.handleError(t('socialMedia.components.createPost.errors.noLastParams'))
    return false
  }
  
  const { type, data } = state.lastGenerationParams.value
  
  // Determine which generation function to use
  if (type === 'trend' && generateFuncs.fromTrend) {
    return await generateFuncs.fromTrend(data, assetStore)
  } else if (type === 'manual' && generateFuncs.manual) {
    return await generateFuncs.manual(data, assetStore)
  }
  
  responseHandlerService.handleError(t('socialMedia.components.createPost.errors.regenerateFailed'))
  return false
}
